import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import { ViewportOverlayDirective } from '../../common/directives/viewport-overlay/viewport-overlay.directive';
import { formatReviewWindowDays } from '../../services/auto-decline-explainer/auto-decline-explainer.helpers';

@Component({
  selector: 'atom-auto-decline-explainer',
  hostDirectives: [ViewportOverlayDirective],
  templateUrl: './auto-decline-explainer.html',
  styleUrl: './auto-decline-explainer.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:keydown.escape)': 'dismiss()',
  },
})
export class AutoDeclineExplainer {
  readonly days = input.required<number>();
  readonly close = output<void>();

  private readonly panel = viewChild<ElementRef<HTMLElement>>('panel');

  readonly daysLabel = computed(() => formatReviewWindowDays(this.days()));

  constructor() {
    afterNextRender(() => {
      this.panel()?.nativeElement.focus();
    });
  }

  dismiss(): void {
    this.close.emit();
  }
}
